export default {
  state: {
    //当前选中文档类型
    currOrderDocType: null,
    //当前工单文档列表
    currOrderDocList: null,
    //当前预览文档id
    currOrderDocId: null
  },
  mutations: {
    //设置当前选中文档类型
    setCurrOrderDocType(state, currOrderDocType){
      state.currOrderDocType = currOrderDocType
    },
    //设置当前工单文档列表
    setCurrOrderDocList(state, currOrderDocList){
      state.currOrderDocList = currOrderDocList
    },
    //设置当前工单文档id
    setCurrOrderDocId(state, currOrderDocId){
      state.currOrderDocId = currOrderDocId
    },
  },
  actions:{
  },
  getters:{
    getCurrOrderDoc(state){
      if(!state.currOrderDocList || !state.currOrderDocId){
        return null
      }
      let document = state.currOrderDocList.find(item => item.id == state.currOrderDocId)
      return document
    }
  },
}